import { isApp } from '~/js/helpers/user-agent-helper'
const ID = 'SmBnLink'
const ID_BUTTON = `${ID}-button`

window.addEventListener('DOMContentLoaded', () => {
  const element = document.getElementById(ID)
  if (!element) return

  if (sessionStorage.getItem('isSmartUpBannerClosed')) return

  if (
    (navigator.userAgent.indexOf('iPhone') != -1 ||
      navigator.userAgent.indexOf('iPad') != -1 ||
      navigator.userAgent.indexOf('iPod') != -1) &&
    !isApp()
  ) {
    element.style.display = 'block'
  } else if (navigator.userAgent.indexOf('Android') != -1 && !isApp()) {
    element.style.display = 'block'
    element.href =
      'https://play.google.com/store/apps/details?id=jp.co.bals.francfranc.app'
  }

  const buttonElement = element.getElementsByClassName(ID_BUTTON)[0]
  buttonElement.addEventListener('click', (event) => {
    event.preventDefault()
    element.style.marginTop = `-${element.clientHeight}px`
    sessionStorage.setItem('isSmartUpBannerClosed', true)
  })
})
